import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import { PermissionGate } from '@saas/ui';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

function guarded(load: () => Promise<PageModule>, anyOf: string[]): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    const Page = m.default;
    const Guarded = () => (
      <PermissionGate anyOf={anyOf}>
        <Page />
      </PermissionGate>
    );
    return { Component: Guarded };
  };
}

const EVENT_READ = ['safety.event.read', 'safety.event.manage'];

/** ログイン後（シェルの中・ModuleGate の下） */
export const safetyRoutes: RouteObject[] = [
  { path: '/safety', lazy: guarded(() => import('./pages/SafetyEventsPage.js'), EVENT_READ) },
  { path: '/safety/me', lazy: page(() => import('./pages/MySafetyPage.js')) },
  { path: '/safety/fire', lazy: guarded(() => import('./pages/FireEventPage.js'), ['safety.event.manage']) },
  { path: '/safety/events/:id', lazy: guarded(() => import('./pages/SafetyEventDetailPage.js'), EVENT_READ) },
  { path: '/safety/drafts', lazy: guarded(() => import('./pages/SafetyDraftsPage.js'), EVENT_READ) },
  { path: '/safety/settings', lazy: guarded(() => import('./pages/SafetySettingsPage.js'), ['safety.event.manage']) },
  { path: '/safety/triggers', lazy: guarded(() => import('./pages/TriggersPage.js'), ['safety.trigger.manage']) },
  { path: '/safety/templates', lazy: guarded(() => import('./pages/TemplatesPage.js'), ['safety.template.manage']) },
  { path: '/safety/reports', lazy: guarded(() => import('./pages/DrillReportsPage.js'), ['safety.report.read', 'safety.event.manage']) },
];

/**
 * ログイン不要の公開ルート（署名付き URL からの回答・02 §7.1.1）。
 * apps/web/src/app/router.tsx では PublicOnly（ログイン済みなら / へ戻す）でも RequireAuth でもない側に登録する。
 * 認証基盤が落ちていても開ける画面なので、シェルも useAuth も使わない。
 */
export const safetyPublicRoutes: RouteObject[] = [{ path: '/safety/respond/:token', lazy: page(() => import('./pages/RespondPage.js')) }];
